import passkeyErrorSrc from '@corbado/shared-ui/assets/passkey-error.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const PasskeyErrorIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, passkeyErrorSrc);
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, ...props }));
});
